// extracted by mini-css-extract-plugin
export default {"TitleInput":"P_k_skPvCczlZjE1vki3","ButtonContainer":"FBFXEHvcLyz6DY9bX3vg","AddNewAnswerButton":"KKKUspCCQ5k1ilOmzJYh","DeleteButton":"ps2chxQ_NoKpDHmtYYvn"};